module.exports = "<div class=\"col-sm-10 col-md-10 main\">\n  <h1 class=\"page-header\">Currency Group Settings</h1>\n  <div id='jqxWidget' style=\"font-size: 13px; font-family: Verdana; float: left; width: 100%; height: 50%;\">\n    <div id=\"jqxgrid\"></div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /app/wiserisk-core/src/main/ng4app/src/app/pages/settings/currency-groups/currency-groups.component.html
// module id = ../../../../../src/app/pages/settings/currency-groups/currency-groups.component.html
// module chunks = main